import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import type { MattressBaseAdvert as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import bannerStyles from "../../styles/composable/banner.module.scss";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Renders the sealy mattress-base advert. The block is a value-less
 * StaticBlock: the serialized value is an empty object (or null) and is
 * ignored.
 */
export const MattressBaseAdvert = (_props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <section
            className={concatClassNames([
                bannerStyles.banner,
                bannerStyles.bannerGrey,
            ])}
        >
            <figure className={bannerStyles.bannerFigure}>
                <img
                    className="img-responsive"
                    src={`${staticURL}img/advert/banner-adjustable.png`}
                    alt="Sealy Adjustable Bases"
                    loading="lazy"
                    decoding="async"
                />
            </figure>
            <div className={bannerStyles.bannerContent}>
                <h3>{t`Live the dream every night`}</h3>
                <p className={bannerStyles.bannerCopy}>
                    {t`With an adjustable base, lounging in bed has never been easier. You can drink your morning coffee, read in bed, or even lounge in bed like you’re on vacation.`}
                </p>
                {/* Static Wistia popover markup transcribed verbatim (including the pre-initialized ids the legacy template hardcoded); the global widgets scanner binds it on load -- no JS here. */}
                <span
                    className="wistia_embed wistia_async_edomjia2fr popover=true popoverAnimateThumbnail=true popoverContent=link wistia_embed_initialized"
                    style={{ display: "inline" }}
                    id="wistia-edomjia2fr-1"
                >
                    <div
                        id="wistia_31.thumb_container"
                        className="wistia_click_to_play"
                        style={{ position: "relative", display: "inline" }}
                    >
                        <a
                            className={bannerStyles.bannerCta}
                            href="#"
                            title={t`Play Video`}
                        >
                            {t`Watch the video`}
                        </a>
                    </div>
                </span>
            </div>
        </section>
    );
};
